(() => {
  const init = () => {
    const html = document.documentElement;
    const isTop = location.pathname === "/" || location.pathname === "";
    html.classList.toggle("tb-top", isTop);

    const wrapper = document.querySelector(".header-wrapper");
    if (!wrapper) return;

    // TOP以外は必ずクラス掃除
    if (!isTop) {
      wrapper.classList.remove("tb-skeleton", "tb-scrolled");
      return;
    }

    const threshold = 20;

    const apply = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;

      const drawerOpen =
        document.querySelector("details.menu-drawer-container[open]") ||
        document.querySelector("details#Details-menu-drawer-container[open]");

      if (drawerOpen) {
        wrapper.classList.remove("tb-skeleton");
        wrapper.classList.add("tb-scrolled");
        return;
      }

      wrapper.classList.toggle("tb-skeleton", y <= threshold);
      wrapper.classList.toggle("tb-scrolled", y > threshold);
    };

    apply();
    window.addEventListener("scroll", apply, { passive: true });
    window.addEventListener("touchmove", apply, { passive: true });

    document.addEventListener("toggle", (e) => {
      if (e.target?.matches?.("details.menu-drawer-container, details#Details-menu-drawer-container")) apply();
    });

    document.addEventListener("click", (e) => {
      if (e.target?.closest?.(".header__icon--menu, summary")) setTimeout(apply, 0);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();